import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import { useAuthStore } from './stores/auth.store'
import './assets/next-colors.css'
import './style.css'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)

const authStore = useAuthStore()
authStore.init()

window.addEventListener('message', (event) => {
  if (event.data?.type !== 'theme')
    return
  const scheme = event.data.scheme === 'dark' ? 'dark' : 'light'
  document.documentElement.style.colorScheme = scheme
  document.documentElement.classList.toggle('dark', scheme === 'dark')
  document.documentElement.classList.toggle('light', scheme !== 'dark')
  window.parent.postMessage?.({ type: 'theme:ack' }, event.origin)
})

app.mount('#app')
